import { GetShopProductColorOptionsQuery } from './getShopProductColorOptions';

type GetShopProductColorOptionsQueryWrapper = {
  data: GetShopProductColorOptionsQuery;
  extensions: {
    cost: {
      'shop-product-catalog': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    shopProductBySkuId: {
      id: '99',
      colorOptions: [
        {
          name: 'Grey',
          uniqueColorId: '281745',
          inventory: {
            availability: 'AVAILABLE_STOCK',
          },
        },
      ],
    },
  },
  extensions: {
    cost: {
      'shop-product-catalog': {
        maxQueryCost: 5000,
        requestedQueryCost: 17,
        actualQueryCost: 141,
      },
    },
  },
} as GetShopProductColorOptionsQueryWrapper;
